import GetUsers from '@/graphql/Users/GetUsers.gql'
import AddUser from '@/graphql/Users/AddUser.gql'
import getUserById from '@/graphql/Users/getUserById.gql'
import UpdateUser from '@/graphql/Users/UpdateUser.gql'
import GetOfferVoterPermission from '@/graphql/Users/GetOfferVoterPermission.gql'
import SetOfferVoterPermission from '@/graphql/Users/SetOfferVoterPermission.gql'

import { createProvider } from '../../vue-apollo'

const apollo = createProvider()

export default {
  async getUsers ({ commit, dispatch }, { pageNumber, perPage, search }) {
    try {
      const { data } = await apollo.defaultClient.query({
        query: GetUsers,
        fetchPolicy: 'no-cache',
        variables: {
          pageNumber: pageNumber,
          perPage: perPage || 10,
          search: search || ''
        }
      })
      return data.Users
    } catch (error) {
      dispatch('showError', error)
    }
  },

  async getUserById ({ dispatch }, userId) {
    try {
      const result = await apollo.defaultClient.query({
        query: getUserById,
        variables: {
          userId
        }
      })
      return result.data.User
    } catch (error) {
      dispatch('showError', error)
    }
  },

  async addUser ({ commit, dispatch }, userInfo) {
    try {
      const { data } = await apollo.defaultClient.mutate({
        mutation: AddUser,
        variables: {
          user: userInfo
        }
      })
      dispatch('addTemporalNotification', { type: 'success', message: 'El usuario se ha creado correctamente' })
      return data.saveUser
    } catch (error) {
      dispatch('showError', error)
    }
  },

  async updateUser ({ dispatch }, userInfo) {
    try {
      const result = await apollo.defaultClient.mutate({
        mutation: UpdateUser,
        variables: {
          ...userInfo
        }
      })
      dispatch('addTemporalNotification', { type: 'success', message: 'El usuario se ha actualizado correctamente' })
      return result.data.updateUser
    } catch (error) {
      dispatch('showError', error)
    }
  },

  async getOfferVoterPermission ({ dispatch }, userId) {
    try {
      const { data } = await apollo.defaultClient.query({
        query: GetOfferVoterPermission,
        variables: {
          userId: Number(userId)
        },
        fetchPolicy: 'no-cache'
      })
      return data.getOfferVoterPermission
    } catch (error) {
      dispatch('showError', error)
    }
  },

  async setOfferVoterPermission ({ dispatch }, { userId, enabled, points }) {
    try {
      const { data } = await apollo.defaultClient.mutate({
        mutation: SetOfferVoterPermission,
        variables: {
          userId: Number(userId),
          enabled: !!enabled,
          points: Number(points)
        }
      })
      return data.setOfferVoterPermission
    } catch (error) {
      dispatch('showError', error)
    }
  }
}
